export const selectMessage = (payload) => {
  if (payload.newMessage) {
    return {
      ...payload.messageObject[
        payload.responseCode !== null ? Number(payload.responseCode) : 99
      ],
      message: payload.newMessage,
    };
  }
  return {
    ...payload.messageObject[
      payload.responseCode !== null ? Number(payload.responseCode) : 99
    ],
  };
};
